import supported from '../content/translations/supported-locales.json';
import type { Locale } from '../content/translations';
export const LANGUAGE_COOKIE = "metal-asia-locale";

export function localeFromRequest(request: Request, country?: string | null): Locale {
  const match = (request.headers.get("cookie") ?? "").split(";").map(part => part.trim())
    .find(part => part.startsWith(`${LANGUAGE_COOKIE}=`));
  let stored: string | undefined;
  try { stored = match ? decodeURIComponent(match.slice(LANGUAGE_COOKIE.length + 1)) : undefined; } catch { /* Ignore malformed visitor cookies. */ }
  const languages = (request.headers.get("accept-language") ?? "").split(",").map((entry, index) => {
    const [language, weight] = entry.trim().split(";");
    const quality = weight?.trim().startsWith("q=") ? Number(weight.trim().slice(2)) : 1;
    return { language, quality, index };
  }).filter(item => item.quality > 0 && item.quality <= 1)
    .sort((a, b) => b.quality - a.quality || a.index - b.index).map(item => item.language);
  return resolveVisitorLocale({ stored, country, languages });
}

const countryLocales: Record<string, Locale> = {
  TR: 'tr', RU: 'ru', KZ: 'kk', KG: 'ky', UZ: 'uz', TJ: 'tg', TM: 'tk',
  GB: 'en', US: 'en', AU: 'en', NZ: 'en', IE: 'en', CA: 'en',
};
export function localeForCountry(country?: string | null): Locale | null {
  return countryLocales[country?.trim().toUpperCase() ?? ''] ?? null;
}
export function localeFromLanguages(languages: readonly string[]): Locale | null {
  for (const language of languages) {
    const base = language.trim().toLowerCase().split(/[-_]/)[0];
    if (Object.hasOwn(supported, base)) return base as Locale;
  }
  return null;
}
export function resolveVisitorLocale({ stored, country, languages = [] }: {
  stored?: string | null; country?: string | null; languages?: readonly string[];
}): Locale {
  if (stored && Object.hasOwn(supported, stored)) return stored as Locale;
  return localeForCountry(country) ?? localeFromLanguages(languages) ?? 'en';
}
export function orderedLanguages(current?: Locale): Locale[] {
  const order = Object.keys(supported) as Locale[];
  return current ? [current, ...order.filter(locale => locale !== current)] : order;
}
